import { render, staticRenderFns } from "./licenciamentos.vue?vue&type=template&id=2ae95c73&"
import script from "./licenciamentos.vue?vue&type=script&lang=js&"
export * from "./licenciamentos.vue?vue&type=script&lang=js&"
import style0 from "./licenciamentos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports